import React from "react";
import i18next from "i18next";

export const returnValue = (item: any) => {
  // TODO: Type
  const dateTimeRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\+\d{2}:\d{2}$/;
  const dateTimeRegex2 = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/;

  function isImage(url: string) {
    try {
      const urlObj = new URL(url);
      return /\.(jpg|jpeg|png|webp|avif|gif|svg)$/i.test(urlObj.pathname);
    } catch {
      return false;
    }
  }

  function isUrl(url: string) {
    return /^(https|http)/.test(url);
  }

  if (
    item !== null &&
    !isNaN(new Date(item).getTime()) &&
    (dateTimeRegex.test(item) ||
      dateTimeRegex2.test(item) ||
      item.toString().length === 13 ||
      item.toString().length === 14)
  ) {
    return new Date(item).toLocaleString("de");
  } else if (typeof item === "boolean") {
    return item.toString();
  } else if (isUrl(item)) {
    if (isImage(item)) {
      return (
        <a target="_blank" href={item} rel="noreferrer">
          {i18next.t("general.open")}
        </a>
      );
    } else {
      return (
        <a target="_blank" href={item} rel="noreferrer">
          {item}
        </a>
      );
    }
  } else if (Array.isArray(item)) {
    return item.join(", ");
  } else if (typeof item === "object") {
    return item?._content_?.timePosition;
  } else if (item === null) {
    return "";
  } else {
    return item;
  }
};
